export function getStateAndCityUseCase(addressLocationsData, addressLocationsRepository) {

    const address = new addressLocationsRepository.model(addressLocationsData);
  
    if (!address.isValid()) {
      throw new Error("address.zipcode is not valid");
    }
  
    return addressLocationsRepository.get_state_and_city(address);
}